import { utils } from 'myvetools';
import ABI from '@Abi';
import '@vechain/connex';

export default class ConnexService {
  static getInstance(contractAddress) {
    if (!ConnexService.instance) {
      ConnexService.instance = new ConnexService();
      this.contractAddress = contractAddress;
    }
    return this.instance;
  }

  static transferEvent(abiName) {
    return window.connex.thor
      .account(this.contractAddress)
      .event(utils.getABI(ABI, abiName, 'event'));
  }

  static transferMethod(abiName, signer = this.contractAddress) {
    return window.connex.thor
      .account(signer)
      .method(utils.getABI(ABI, abiName, 'function'));
  }

  static async signingService(abiName, signer, data) {
    try {
      const transferMethod = this.transferMethod(abiName);
      if (!transferMethod) {
        return undefined;
      }
      const asClause = transferMethod.asClause(...data);
      console.log(asClause);
      if (!asClause) {
        return undefined;
      }
      const service = window.connex.vendor.sign('tx');
      if (!service) {
        return undefined;
      }
      service.signer(signer).gas(0);
      const response = await service.request([{ ...asClause }]);
      if (!response) {
        return undefined;
      }
      return Promise.resolve(response.txid);
    } catch (err) {
      throw Error(err);
    }
  }

  static async login() {
    const { connex } = window;
    try {
      if ('account' in connex.thor) {
        const acc = connex.thor.account(this.contractAddress);
        const code = await acc.getCode();
        if (code.code === '0x') {
          throw Error('You have selected an incompatible environment. Please change your node to proceed.');
        } else {
          const SigningService = connex.vendor.sign('cert');
          const response = await SigningService.request({
            purpose: 'identification',
            payload: {
              type: 'text',
              content: 'Wallet Authorization',
            },
          });
          return Promise.resolve(response.annex);
        }
      }
      return undefined;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async fetchTransferHistoryList({
    _tokenId,
    offset = 0,
    limit = 10,
  }) {
    try {
      const out = await this.transferEvent('Transfer')
        .filter([{ _tokenId }])
        .order('desc')
        .apply(offset, limit);
      if (!out.length) {
        return undefined;
      }
      return out;
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  }

  static async getReceipt(txid) {
    try {
      const transaction = window.connex.thor.transaction(txid);
      return new Promise((resolve) => {
        let receipt;
        const timeid = setInterval(async () => {
          if (!receipt) {
            receipt = await transaction.getReceipt();
            if (receipt) {
              clearInterval(timeid);
              resolve(receipt);
            }
          }
        }, 1000 * 5);
      });
    } catch (err) {
      throw Error(err);
    }
  }

  static async transfer(signer, data) {
    try {
      const txID = await this.signingService('transfer', signer, data);
      if (!txID) {
        return false;
      }
      const receipt = await this.getReceipt(txID);
      if (receipt.reverted) {
        throw Error('Transaction Reverted');
      }
      console.log({ receipt });
      return receipt;
    } catch (err) {
      throw new Error(err);
    }
  }

  static async ownerOf(tokenId) {
    try {
      const out = await this.transferMethod('ownerOf').call(tokenId);
      if (!out) {
        return false;
      }
      return out.decoded['0'];
    } catch (err) {
      throw new Error(err);
    }
  }

  static async balanceOf(signer) {
    try {
      const out = await this.transferMethod('balanceOf').call(signer);
      console.log(out);
      if (!out) {
        return false;
      }
      return out.decoded['0'];
    } catch (err) {
      throw new Error(err);
    }
  }

  static async tokenURI(tokenId) {
    try {
      const out = await this.transferMethod('tokenURI').call(tokenId);
      if (!out) {
        return false;
      }
      return out.decoded['0'];
    } catch (err) {
      throw new Error(err);
    }
  }
}
